var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BackendHttpService } from '../../core/backend-http.service';
import { apiEndpoints } from '../../app.constants';
import { ObjectUtils } from '../../utils/object.utils';
import { UserService } from '../../services/user.service';
import { EventTrackerService } from '../../services/event-tracker/event-tracker.service';
var PdfViewerService = /** @class */ (function (_super) {
    __extends(PdfViewerService, _super);
    function PdfViewerService(router, translate, eventTracker, userService) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        _this.eventTracker = eventTracker;
        _this.userService = userService;
        return _this;
    }
    PdfViewerService.prototype.getUserToken = function () {
        if (!localStorage.getItem('user')) {
            return null;
        }
        var user = ObjectUtils.parseJSON(localStorage.getItem('user'));
        return user.token;
    };
    /**
     * to get influencer details pdf file
     * @param influencerId
     * @returns {file}
     */
    PdfViewerService.prototype.generateInfluencerDetailPdf = function (influencerId, demographicChannel, activeAccountId, channelFollowerId, insightChannelParam) {
        var params = { activeAccount: activeAccountId, accessToken: this.getUserToken() };
        // add channel in pdf url
        if (demographicChannel) {
            params = Object.assign({}, params, {
                demographicChannel: demographicChannel
            });
        }
        if (insightChannelParam) {
            params = Object.assign({}, params, {
                insightChannel: insightChannelParam
            });
        }
        if (channelFollowerId) {
            params = Object.assign({}, params, {
                channelFollower: channelFollowerId
            });
        }
        return this.get(apiEndpoints.generateInfluencerDetailPdf + influencerId, params)
            .map(function (res) {
            return res;
        });
    };
    /**
     * generate campaign pdf file
     * @param influencerId
     * @returns {file}
     */
    PdfViewerService.prototype.generateCampaignPdf = function (campaignInfluencerId) {
        var params = { accessToken: this.getUserToken() };
        return this.get(apiEndpoints.generateCampaignPdf + campaignInfluencerId, params)
            .map(function (res) {
            return res;
        });
    };
    /**
     * to get post overview pdf file
     * @param data
     * @returns {file}
     */
    PdfViewerService.prototype.generatePostOverviewPdf = function (data, activeAccountId) {
        var tokenObj = { accessToken: this.getUserToken(), activeAccount: activeAccountId };
        var params = Object.assign(tokenObj, data);
        return this.get(apiEndpoints.generatePostOverviewPdf, params)
            .map(function (res) {
            return res;
        });
    };
    /**
     * to get measure pdf file
     * @param data
     * @returns {file}
     */
    PdfViewerService.prototype.generateMeasurePdf = function (data, activeAccountId) {
        var tokenObj = { accessToken: this.getUserToken(), activeAccount: activeAccountId };
        var params = Object.assign(tokenObj, data);
        return this.get(apiEndpoints.generateMeasurePdf, params)
            .map(function (res) {
            return res;
        });
    };
    return PdfViewerService;
}(BackendHttpService));
export { PdfViewerService };



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/pdf-viewer.service.ts.pre-build-optimizer.js